import { createStore } from 'vuex';
import modules from './modules';

export default function createStoreInstance() {
	return createStore({
		state: {
			count: 1000,
			voteScore: null,
		},
		modules,
		mutations: {
			UPDATE_VOTING(state, num) {
				state.voteScore = num;
			},
		},
	});
}
